import React, { Component } from 'react';
import { Alert, Clearfix, Grid, Row } from "react-bootstrap";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from "react-dates";
import { END_DATE, START_DATE } from "react-dates/constants";
import Button from "@material-ui/core/Button";
import moment from "moment";
import axios from "axios";
import { backendDomain } from "../modules/configs";
import PrintDataOverview from "./print-data-overview";
import PrintDataResinUsage from "./print-data-resin-usage";
import PrintDataPrintTime from "./print-data-print-time";
import PrintDataResinUsed from "./print-data-resin-used";
import PrintDataThickness from "./print-data-thickness";
import PrintDataPrintFrequency from "./print-data-print-frequency";
import PrintDataPrintTimeAndResinUsage from "./print-data-print-time-and-resin-usage";
import PrintDataPrintJobOutcome from "./print-data-print-job-outcome";
import Drawer from "@material-ui/core/Drawer";
import { MASTER_DASHBOARD_CHART_TYPE } from '../common/constants'
import { PrinterStatusTypes } from "../containers/current_status_section";
import PrintDataExcel from "./print-data-excel";


const DEFAULT_RESIN = "all";
export default class PrintDataContent extends Component {
    constructor(props) {
        super(props);
        const initEndDate = moment().endOf('day');
        const earliestTimestamp = 1527893484649;
        const initStartDate = moment(earliestTimestamp).startOf('day');
        this.initState = {
            initEndDate,
            initStartDate
        };
        this.state = {
            authSuccess: true,
            focusedInput: null,
            startDate: this.initState.initStartDate,
            endDate: this.initState.initEndDate,
            startTime: null,
            endTime: null,
            printAndPrinterData: {
                print: {},
                printer: {}
            },
            resinUsageData: {
                resinSets: [],
                usageRangeKeys: [],
                resinUsageResult: {}
            },
            printTimeData: {
                resinSets: [],
                printTimeRangeKeys: [],
                printTimeResult: {}
            },
            resinUsedData: {},
            thicknessData: {},
            printFrequenciesData: {
                day: {},
                week: {},
                month: {}
            },
            prints: [],
            drawerOpen: false,
            excelPrints: []
        };
    }

    componentDidMount() {
        this.startLoadingPrintData();
    }

    startLoadingPrintData = () => {
        const { startDate, endDate } = this.state;
        this.loadAllData(startDate, endDate);
    };

    loadAllData(startDate, endDate) {
        const startTime = startDate.startOf("day").valueOf();
        const endTime = endDate.endOf("day").valueOf();
        this.printAndPrinter({ startTime, endTime })
            .then(r => {
                this.resinUsage(startTime, endTime);
                this.printTime(startTime, endTime);
                this.resinUsedPerPrinter(startTime, endTime);
                this.printGroupByThickness(startTime, endTime);
                this.printFrequency(startTime, endTime);
                this.printTimeAndResinUsed(startTime, endTime);
            })
    }

    resinUsage(startTime, endTime) {
        axios.get(`${backendDomain}/analytics/printGroupByResinUsage`, {
            params: {
                startTime,
                endTime
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res || !res.data) {
                    return
                }
                const resinUsageData = res.data;
                this.setState({
                    resinUsageData
                });
            })
    };

    printTime(startTime, endTime) {
        axios.get(`${backendDomain}/analytics/printGroupByPrintTime`, {
            params: {
                startTime,
                endTime
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res || !res.data) {
                    return
                }
                const printTimeData = res.data;
                this.setState({
                    printTimeData
                })
            })
    };

    resinUsedPerPrinter(startTime, endTime) {
        axios.get(`${backendDomain}/analytics/resinUsedPerPrinter`, {
            params: {
                startTime,
                endTime
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res) {
                    return
                }
                const resinUsedData = res.data;
                this.setState({
                    resinUsedData
                })
            })
    };

    printGroupByThickness(startTime, endTime) {
        axios.get(`${backendDomain}/analytics/printGroupByLayerThickness`, {
            params: {
                startTime,
                endTime
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res) {
                    return
                }
                const thicknessData = res.data;
                this.setState({
                    thicknessData
                })
            })
    };

    printAndPrinter = async ({ startTime, endTime }) => {
        await axios.get(`${backendDomain}/analytics/printAndPrinter`, {
            params: {
                startTime,
                endTime
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res || !res.data) {
                    return
                }
                const printAndPrinterData = res.data;
                this.setState({
                    startTime,
                    endTime,
                    printAndPrinterData
                })
            })
            .catch(err => {
                if (err && err.response && err.response.status === 401) {
                    this.setState({ authSuccess: false })
                }
            })
    };

    printFrequency(startTime, endTime) {
        axios.get(`${backendDomain}/analytics/printFrequencies`, {
            params: {
                startTime,
                endTime,
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res) {
                    return
                }
                const printFrequenciesData = res.data;
                this.setState({
                    printFrequenciesData
                })
            })
    };

    printTimeAndResinUsed(startTime, endTime) {
        axios.get(`${backendDomain}/analytics/prints`, {
            params: {
                startTime,
                endTime,
            },
            headers: { Authorization: `Bearer ${localStorage.access_token}` }
        })
            .then(res => {
                if (!res) {
                    return
                }
                const prints = res.data;
                this.setState({
                    prints
                })
            })
    }

    onFocusChange = (focusedInput) => {
        this.setState({ focusedInput });
    };

    handleDatesChange = ({ startDate, endDate }) => {
        if (!(startDate && endDate)) {
            return
        }
        this.setState({
            startDate,
            endDate
        });
        this.loadAllData(startDate, endDate);
    };

    toggleDrawer = (drawerOpen) => {
        this.setState({
            drawerOpen,
        });
    };

    handleChartsClick = (chartDetail) => {
        const excelPrints = this.resolvePrintsData(this.state.prints, chartDetail);
        this.setState({ excelPrints, drawerOpen: true });
    };

    resolvePrintsData = (prints, chartDetail) => {
        const endPrints = prints.filter(item => item.status === PrinterStatusTypes.END);
        const { chartType, label, value } = chartDetail;
        let result = [];
        if (chartType === MASTER_DASHBOARD_CHART_TYPE.RESIN_USAGE) {
            const [start, end] = label.split('-').map(item => Number(item));
            const resin = chartDetail.resin;
            const shouldFilterResin = chartDetail.resin !== DEFAULT_RESIN;
            result = endPrints.filter(item => {
                return (item.resinUsage > start && item.resinUsage <= end && (shouldFilterResin ? item.resinColor === resin : true));
            });
        } else if (chartType === MASTER_DASHBOARD_CHART_TYPE.PRINT_TIME) {
            const [start, end] = label.split('-').map(item => Number(item));
            const resin = chartDetail.resin;
            const shouldFilterResin = chartDetail.resin !== DEFAULT_RESIN;
            result = endPrints.filter(item => {
                return (item.totalPrintTime > start && item.totalPrintTime <= end && (shouldFilterResin ? item.resinColor === resin : true));
            });
        } else if (chartType === MASTER_DASHBOARD_CHART_TYPE.PRINT_TIME_AND_RESIN_USAGE) {
            const printTime = value.x;
            const resinUsage = value.y;
            result = prints.filter(item => {
                return (item.totalPrintTime === printTime && item.resinUsage === resinUsage)
            })
        } else if (chartType === MASTER_DASHBOARD_CHART_TYPE.THICKNESS) {
            const thickness = Number(label);
            result = endPrints.filter(item => {
                return (item.layerThickness === thickness)
            })
        } else if (chartType === MASTER_DASHBOARD_CHART_TYPE.PRINT_OUTCOME) {
            const status = label;
            const { resin, thickness } = chartDetail;
            result = prints.filter(item => {
                return item.status === status && (resin ? item.resinColor === resin : true) && (thickness ? item.layerThickness === thickness : true)
            })
        } else if (chartType === MASTER_DASHBOARD_CHART_TYPE.PRINT_OVERVIEW) {
            const { start, end } = chartDetail;
            result = endPrints.filter(item => {
                return item.timeStamp > start && item.timeStamp < end;
            })
        }
        return result;
    };

    resetDateRange = () => {
        const startDate = this.initState.initStartDate;
        const endDate = this.initState.initEndDate;
        this.handleDatesChange({ startDate, endDate })
    };

    render() {
        const { focusedInput, startDate, endDate } = this.state;
        const initialVisibleMonth = focusedInput === START_DATE ? () => startDate : () => endDate;
        return (
            <div>
                <div style={{ padding: '0 20 0 20' }}>
                    {
                        !this.state.authSuccess &&
                        <Alert bsStyle='warning'>
                            This account have no access. Please use right account.
                        </Alert>
                    }
                    {
                        this.state.authSuccess &&
                        <div className="print-data-content">
                            <Drawer anchor="right" open={this.state.drawerOpen}
                                    onClose={() => this.toggleDrawer(false)}>
                                <div
                                    tabIndex={0}
                                    role="button"
                                >
                                    <PrintDataExcel prints={this.state.excelPrints}/>
                                </div>
                            </Drawer>
                            <div className="float-right" style={{ marginBottom: 40 }}>
                                <DateRangePicker
                                    onDatesChange={this.handleDatesChange}
                                    onFocusChange={this.onFocusChange}
                                    focusedInput={focusedInput}
                                    startDate={startDate}
                                    endDate={endDate}
                                    enableOutsideDays={true}
                                    minimumNights={0}
                                    isOutsideRange={() => false}
                                    startDateId={START_DATE}
                                    endDateId={END_DATE}
                                    initialVisibleMonth={initialVisibleMonth}
                                />
                                <Button variant="outlined" style={{ height: 48 }}
                                        onClick={this.resetDateRange}>reset</Button>
                            </div>
                            <Clearfix/>

                            <PrintDataOverview startTime={this.state.startTime} endTime={this.state.endTime}
                                               printAndPrinterData={this.state.printAndPrinterData}
                                               handleChartsClick={this.handleChartsClick}/>
                            <Grid fluid={true} className='grid-content'>
                                <Row>
                                    <PrintDataResinUsage resinUsageData={this.state.resinUsageData}
                                                         handleChartsClick={this.handleChartsClick}/>
                                    <PrintDataPrintTime printTimeData={this.state.printTimeData}
                                                        handleChartsClick={this.handleChartsClick}/>
                                </Row>
                            </Grid>
                            <Grid fluid={true} className='grid-content'>
                                <Row>
                                    <PrintDataPrintTimeAndResinUsage prints={this.state.prints}
                                                                     handleChartsClick={this.handleChartsClick}/>
                                </Row>
                            </Grid>
                            <Grid fluid={true} className='grid-content'>
                                <Row>
                                    <PrintDataResinUsed resinUsedData={this.state.resinUsedData}/>
                                    <PrintDataThickness thicknessData={this.state.thicknessData}
                                                        handleChartsClick={this.handleChartsClick}/>
                                </Row>
                            </Grid>
                            <Grid fluid={true} className='grid-content'>
                                <Row>
                                    <PrintDataPrintFrequency printFrequenciesData={this.state.printFrequenciesData}/>
                                    <PrintDataPrintJobOutcome prints={this.state.prints}
                                                              handleChartsClick={this.handleChartsClick}/>
                                </Row>
                            </Grid>
                        </div>
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-content.js